module.exports = __webpack_public_path__ + "img/logo1.0a68895f.png";